import * as yup from 'yup'

export const addEditMappedFieldsValidation: yup.SchemaOf<any> = yup
  .object({
    MappingType: yup.string().required().label('Mapping Type').typeError('Invalid Input'),
    FieldValue: yup.string().required().label('Value').typeError('Invalid Input'),
  })
  .required()
